"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
function getHeaderTextFromHeaderType(headerType) {
    switch (headerType) {
        case 'organize':
            return owa_options_strings_1.default.options_inboxRules_organize;
        case 'markMessage':
            return owa_options_strings_1.default.options_inboxRules_markMessage;
        case 'route':
            return owa_options_strings_1.default.options_inboxRules_route;
        case 'addresses':
            return owa_options_strings_1.default.options_inboxRules_people;
        case 'myNameIs':
            return owa_options_strings_1.default.options_inboxRules_myNameIs;
        case 'subject':
            return owa_options_strings_1.default.options_inboxRules_subject;
        case 'includesTheseWords':
            return owa_options_strings_1.default.options_inboxRules_includesWords;
        case 'markedWith':
            return owa_options_strings_1.default.options_inboxRules_markedWith;
        case 'messageIncludes':
            return owa_options_strings_1.default.options_inboxRules_messageIncludes;
        case 'messageSize':
            return owa_options_strings_1.default.options_inboxRules_messageSize;
        case 'received':
            return owa_options_strings_1.default.options_inboxRules_received;
        default:
            throw new Error('Cannot get header text for a header type that does not exist');
    }
}
exports.default = getHeaderTextFromHeaderType;
//# sourceMappingURL=getHeaderTextFromHeaderType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getHeaderTextFromHeaderType.js
// module id = 5197
// module chunks = 2